<template>
    <div>
        <p class="title title-step">
            {{'components.pages.registration.step2' | translate}}
            <a @click="toStep1()">&lt; {{"components.pages.registration.back to step 1" | translate}}</a>
        </p>
        <p class="title title-step">{{ "components.pages.registration.step 2 title" | translate }}</p>
        <p class="subtitle is-5">{{ "components.pages.registration.step 2 message" | translate }}</p>

        <form @submit.prevent="submit()" :class="{ 'is-loading' : loading }" role="form">
            <div class="field has-addons">
                <div class="control">
                    <input
                        v-model.trim="code"
                        v-validate="'required|digits:4'"
                        data-vv-name="confirmation code"
                        data-vv-validate-on="change"
                        :placeholder="'components.pages.registration.confirmation code' | translate"
                        class="input is-large button-confirmation"
                        maxlength="30"
                        ref="code"
                        type="text"
                    />
                    <p
                        class="help is-danger"
                        v-if="errors.has('confirmation code:digits') || confirmationCodeError"
                    >{{"components.pages.registration.validation.confirmation code error" | translate}}</p>
                </div>
                <div class="control">
                    <a class="button is-static is-large">{{countdown}}</a>
                </div>
            </div>
            <button
                class="card-footer-item button is-large is-link button-register"
                :class="{'is-loading': loading}"
                type="submit"
            >
                <span>{{'components.pages.registration.register' | translate}}</span>
            </button>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';

import registrationService from '../../../../../../_common/services/registration.service';
import ymService from '../../../../../../_common/services/ym.service';
import gaService from '../../../../../../_common/services/ga.service';
import utils from '../../../../../../_common/utils';

export default {
    name: 'registration-by-phone-confirmation',
    $_veeValidate: { validator: 'new' },
    props: {
        phone: {
            type: String,
            required: true
        },
        toStep1: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            code: null,
            loading: false,
            timeoutStart: new Date(),
            timeout: 15 * 60 * 1000, // 15 min
            countdown: null,
            countdownTimer: null,
            confirmationCodeError: null
        };
    },
    mounted() {
        this.$refs.code.focus();
        this.startCountdown();
    },
    methods: {
        resetFields() {
            this.code = null;
        },
        goBack() {
            this.$router.go(-1);
        },
        async submit() {
            await this.$validator.validateAll();
            if (this.errors.any() || this.loading) return;

            this.errors.clear();
            this.confirmationCodeError = false;
            this.loading = true;
            try {
                let confirmResult = await registrationService.confirmPhone({
                    code: this.code,
                    phone: this.phone
                });
                if (confirmResult.isSuccess) {
                    await Vue.state.player.reload();
                    Vue.state.lang.ensureLocalLangOrPlayer(Vue.state.player.get().lang || 'en');

                    ymService.send('reachGoal', 'REGISTRATION SUCCESS');
                    gaService.send('registration', 'registrationsuccess', 'registration3');

                    await Vue.router.teleport.afterRegistration();
                }
            } catch (ex) {
                console.error(ex);
                this.confirmationCodeError = true;
            }
            this.loading = false;
        },
        startCountdown() {
            this.countdownTimer && clearInterval(this.countdownTimer);
            this.timeoutStart = new Date();
            this.setCountdown();
            this.countdownTimer = setInterval(() => {
                this.setCountdown();
            }, 1000);
        },
        setCountdown() {
            let diff = this.timeoutStart.valueOf() - new Date().valueOf() + 15 * 60 * 1000;
            diff = Math.max(diff, 0);
            this.countdown = utils.formatDateTime(diff, 'mm:ss');
        }
    },
    beforeDestroy() {
        this.resetFields();
        this.countdownTimer && clearInterval(this.countdownTimer);
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/registration/by-phone-confirmation.vue